<!-- Tiêu Đề Modal -->
<div class="modal-header">
  <h5 class="modal-title" id="renewalModalLabel"><i class="fas fa-refresh"></i> Gia Hạn</h5>
  <button type="button" class="close"(click)="closeModal()" aria-label="Đóng">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Nội Dung Modal -->
<div class="modal-body">
  <form [formGroup]="renewalForm" style="background-color: white; padding: 20px; border-radius: 5px;">
    
    <!-- Chọn Thành Viên -->
    <div class="form-group">
      <label for="member">Thành Viên:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn thành viên gia hạn mục sách."></i>
      <ng-select  id="member" name="member"
                 [items]="members$"
                 bindLabel="firstname" bindValue="id"
                 formControlName="member"
                 placeholder="Chọn thành viên">
      </ng-select>
    </div>

    <!-- Mã Vạch Sách -->
    <div class="form-group">
      <label for="itemBarcode">Mã Vạch Sách:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn mã vạch của sách muốn gia hạn."></i>
      <ng-select  id="itemBarcode" name="itemBarcode"
                 [items]="books$"
                 bindLabel="title" bindValue="id"
                 formControlName="itemBarcode"
                 placeholder="Chọn mã vạch"
                 >
      </ng-select>
    </div>

    <!-- Ngày Đến Hạn Gia Hạn -->
    <div class="form-group">
      <label for="renewalDueDate">Ngày Đến Hạn Gia Hạn:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Nhập ngày đến hạn cho mục sách được gia hạn."></i>
      <input type="date" class="form-control" id="renewalDueDate" name="renewalDueDate" formControlName="renewalDueDate">
    </div>

    <!-- Miễn Phí Phạt Khi Trả -->
    <div class="form-group">
      <label>Miễn phí phạt khi trả:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn có hoặc không miễn phí phạt khi trả sách."></i>
      
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="forgiveFines" id="forgiveFinesYes" value="yes" formControlName="forgiveFines">
        <label class="form-check-label" for="forgiveFinesYes">Có</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="forgiveFines" id="forgiveFinesNo" value="no" formControlName="forgiveFines">
        <label class="form-check-label" for="forgiveFinesNo">Không</label>
      </div>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
  <button type="button" class="btn btn-outline-primary" (click)="renew()">Gia Hạn</button>
</div>
